<template>
    <div class="a-tab" data-tab-panel>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'ATab',

    props: {
        label: {
            type: String,
            required: true,
        },

        labelIcon: {
            type: [String, Number],
            default: undefined,
        },

        labelIconAlt: {
            type: String,
            default: undefined,
        },

        anchorId: {
            type: String,
            default: undefined,
        },

        translatedLabel: {
            type: String,
            default: undefined,
        },
        glyph: {
            type: Object,
            default: null,
        },
        aLabel: {
            type: Object,
            default: null,
        },
    },
};
</script>

<style lang="pcss" scoped>
.a-tab {
    display: none;

    &.a-tab-active {
        display: block;
    }

    :deep(.a-container) {
        padding: 0;
    }
}
</style>
